import * as _ from 'underscore';

import * as config from '../config';
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import StringField from '../../../../_common/platform/ts/StringField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import NumberField from '../../../../_common/platform/ts/NumberField';

const _init = [];

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    appTheme.registerSections([
        {
            id: config.themeId,
            name: config.name,
            parent: 'widget',

            themeType: 'Drill Down Container',
            visibility: ['application', 'workspace', config.moduleName]
        }
    ]);

    appTheme.registerVars([
        {
            id: config.themeFields.headerPlaceHolder,
            param: new StringField(glob, 'Header Placeholder', [], 'Click on a value to drill down'),
            section: config.themeId
        },
        {
            id: config.themeFields.updatePrevWidgetOnBack,
            param: new BooleanField(glob, 'Force update previous widget on "Back"', [], false),
            section: config.themeId
        },
        {
            id: config.themeFields.updateDelayInterval,
            param: new NumberField(glob, 'Update Delay Interval (ms)', [], 1500),
            section: config.themeId
        }
    ]);

    _init.push(glob);
}
